import React from 'react';
import { PictoProps } from './index';

export const ArrowLeft = (props: PictoProps) => (
  <svg
    width={props.width || '17'}
    height={props.height || '16'}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4443 8H1.44434"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.44434 15L1.44434 8L8.44434 1"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
